//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { ICuralateSession } from '@app/basic-session/ICuralateSession';
import {
  getHasModeratorUiaWritePermission,
  getIsModeratorUiaEnabled,
} from '@moderation-mode/moderationModeDerivation';
import {
  MODERATION_STREAM_STATE,
  MODERATOR_DEFAULT_STATE,
} from '@moderation-mode/moderationModeRouteAccess';

export const getModeratorBulkActionsAccess = (
  session: ICuralateSession,
  isModeratorSurface: boolean,
  stateName: string,
) => {
  const isAllSharedMedia = stateName === MODERATOR_DEFAULT_STATE;
  const isStream = stateName === MODERATION_STREAM_STATE;
  const isEnabled =
    (isAllSharedMedia || isStream) &&
    getIsModeratorUiaEnabled(session, isModeratorSurface);

  return {
    isEnabled,
    isAllSharedMedia: isEnabled && isAllSharedMedia,
    isStream: isEnabled && isStream,
    canWrite: isEnabled && getHasModeratorUiaWritePermission(session),
  };
};
